import useLoaderData from "./useLoaderData"

const SHIPPING_PERMISSIONS = [
  'SHIPMENT_TRACKING_READ',
  'SHIPMENT_TRACKING_EDIT',
  'SHIPMENT_TRACKING_PUBLISH',
];

const ASSESSMENT_PERMISSIONS = [
  'ASSESSMENT_BUILDER_READ',
  'ASSESSMENT_BUILDER_EDIT',
  'ASSESSMENT_REPORTS_READ',
];

const QUEST_CODES_PERMISSIONS = [
  'QUEST_CODES_READ',
  'QUEST_CODES_EDIT',
];

const ASSET_MANAGER_PERMISSIONS = [
  'HUB_ADMIN',
];

const IMPLEMENTATION_CALENDAR_PERMISSIONS = [
  'HUB_ADMIN',
];

const QUEST_PERMISSIONS = [
  'QUEST_USER',
  'QUEST_ADMIN',
];

// Reads the data the route loader gathered (Router.js): the verified hub session (auth/verify +
// auth/me on the root API) plus this portal's own profile lookup (accounts/me) for the fields the
// legacy readable login cookies used to carry (name, email, territory).
export default function useMe () {
  const loaderData = useLoaderData()
  const { userId, source, isVerified, name, email, territory } = loaderData
  const permissions = loaderData.permissions || ''

  const has = (perm) => permissions.includes(perm)
  const hasAny = (perms) => perms.some(has)

  return {
    userId,
    permissions,
    source,
    isVerified,
    name,
    email,
    territory,
    isAnyAdmin: Boolean(permissions),
    hasShippingAppAccess: hasAny(SHIPPING_PERMISSIONS),
    hasShipmentTrackingRead: has('SHIPMENT_TRACKING_READ'),
    hasShipmentTrackingEdit: has('SHIPMENT_TRACKING_EDIT'),
    hasShipmentTrackingPublish: has('SHIPMENT_TRACKING_PUBLISH'),
    hasAssessmentAppAccess: hasAny(ASSESSMENT_PERMISSIONS),
    hasAssessmentBuilderEdit: has('ASSESSMENT_BUILDER_EDIT'),
    hasQuestCodesAppAccess: hasAny(QUEST_CODES_PERMISSIONS),
    hasAssetManagerAccess: hasAny(ASSET_MANAGER_PERMISSIONS),
    hasQuestAccess: hasAny(QUEST_PERMISSIONS),
    hasImplementationCalendarAccess: hasAny(IMPLEMENTATION_CALENDAR_PERMISSIONS),
  }
}
